export default __webpack_public_path__ + "static/media/turistas-felices-puente-atras-en-lago.4db4e215.jpeg";